"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductVariantsInnerToJSON = exports.ProductVariantsInnerFromJSONTyped = exports.ProductVariantsInnerFromJSON = exports.instanceOfProductVariantsInner = void 0;
var runtime_1 = require("../runtime");
var ProductVariantsInnerImagesInner_1 = require("./ProductVariantsInnerImagesInner");
var ProductVariantsInnerRgb_1 = require("./ProductVariantsInnerRgb");
var ProductVariantsInnerTrimRgb_1 = require("./ProductVariantsInnerTrimRgb");
var SizesInner_1 = require("./SizesInner");
/**
 * Check if a given object implements the ProductVariantsInner interface.
 */
function instanceOfProductVariantsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductVariantsInner = instanceOfProductVariantsInner;
function ProductVariantsInnerFromJSON(json) {
    return ProductVariantsInnerFromJSONTyped(json, false);
}
exports.ProductVariantsInnerFromJSON = ProductVariantsInnerFromJSON;
function ProductVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'colorId': !(0, runtime_1.exists)(json, 'color_id') ? undefined : json['color_id'],
        'images': !(0, runtime_1.exists)(json, 'images') ? undefined : (json['images'].map(ProductVariantsInnerImagesInner_1.ProductVariantsInnerImagesInnerFromJSON)),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'primaryImageUrl': !(0, runtime_1.exists)(json, 'primary_image_url') ? undefined : json['primary_image_url'],
        'rgb': !(0, runtime_1.exists)(json, 'rgb') ? undefined : (0, ProductVariantsInnerRgb_1.ProductVariantsInnerRgbFromJSON)(json['rgb']),
        'sizes': !(0, runtime_1.exists)(json, 'sizes') ? undefined : (json['sizes'].map(SizesInner_1.SizesInnerFromJSON)),
        'storeProductId': !(0, runtime_1.exists)(json, 'store_product_id') ? undefined : json['store_product_id'],
        'trimRgb': !(0, runtime_1.exists)(json, 'trim_rgb') ? undefined : (0, ProductVariantsInnerTrimRgb_1.ProductVariantsInnerTrimRgbFromJSON)(json['trim_rgb']),
    };
}
exports.ProductVariantsInnerFromJSONTyped = ProductVariantsInnerFromJSONTyped;
function ProductVariantsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'enabled': value.enabled,
        'color_id': value.colorId,
        'images': value.images === undefined ? undefined : (value.images.map(ProductVariantsInnerImagesInner_1.ProductVariantsInnerImagesInnerToJSON)),
        'name': value.name,
        'primary_image_url': value.primaryImageUrl,
        'rgb': (0, ProductVariantsInnerRgb_1.ProductVariantsInnerRgbToJSON)(value.rgb),
        'sizes': value.sizes === undefined ? undefined : (value.sizes.map(SizesInner_1.SizesInnerToJSON)),
        'store_product_id': value.storeProductId,
        'trim_rgb': (0, ProductVariantsInnerTrimRgb_1.ProductVariantsInnerTrimRgbToJSON)(value.trimRgb),
    };
}
exports.ProductVariantsInnerToJSON = ProductVariantsInnerToJSON;
